var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.renderedInfo
    ? _c("div", { staticClass: "swimlane-template-container" }, [
        _c("span", { class: _vm.renderedInfo.class }, [
          _vm._v(_vm._s(_vm.renderedInfo.abbreviation)),
        ]),
        _c("span", { staticClass: "swimlane-text" }, [
          _vm._v(_vm._s(_vm.renderedInfo.text)),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }